import React from 'react';

import {
  useCustomFieldsWidgetQuery,
  useSaveCustomFieldsMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useCustomFieldsWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          creditCardDynamicDescriptor: tuple.data?.store?.creditCardDynamicDescriptor ?? '',
          zenDeskUrl: tuple.data?.store?.zenDeskUrl ?? '',
          additionalSupportText: tuple.data?.store?.additionalSupportText ?? ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveCustomFields(storeId: string) {
  const [fnMutate, tuple] = useSaveCustomFieldsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    (formState: types.IFormState) => {
      fnMutate({
        variables: {
          storeId,
          additionalSupportText: formState.additionalSupportText,
          creditCardDynamicDescriptor: formState.creditCardDynamicDescriptor,
          zenDeskUrl: formState.zenDeskUrl
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
